import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../../../../assets/img/powered-by-asknicely.png'


const _hoisted_1 = ["href"]

type Props = {
    nobranding?: any // TODO: Fix type definition of Params on parent
    referrerUrl?: string
}

export default /*@__PURE__*/_defineComponent({
  __name: 'Footer',
  props: {
    nobranding: {},
    referrerUrl: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", null, [
    (!props.nobranding)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          id: "asknicely-logo",
          href: props.referrerUrl,
          target: "_blank"
        }, _cache[0] || (_cache[0] = [
          _createElementVNode("img", {
            class: "powered-by-b",
            src: _imports_0,
            alt: "Go to AskNicely website to learn more about our product"
          }, null, -1)
        ]), 8, _hoisted_1))
      : _createCommentVNode("", true),
    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "google" }, [
      _createTextVNode("This site is protected by reCAPTCHA and the Google "),
      _createElementVNode("a", { href: "https://policies.google.com/privacy" }, "Privacy Policy"),
      _createTextVNode(" and "),
      _createElementVNode("a", { href: "https://policies.google.com/terms" }, "Terms of Service"),
      _createTextVNode(" apply. ")
    ], -1))
  ]))
}
}

})